import { StyleSheet } from 'react-native';
import { COACH_C, COACH_CARD_WIDTH, COACH_ARROW_SIZE } from './CoachCard.constants';

export const coachStyles = StyleSheet.create({
  card: {
    width: COACH_CARD_WIDTH,
    backgroundColor: COACH_C.card,
    borderColor: COACH_C.cardBorder,
    borderWidth: 1,
    borderRadius: 14,
    paddingTop: 13,
    paddingBottom: 11,
    paddingHorizontal: 14,
    // Glow / lift (RN-web maps to box-shadow; native uses shadow* + elevation)
    shadowColor: '#000',
    shadowOpacity: 0.55,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 14 },
    elevation: 16,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
  },
  avatar: {
    width: 38,
    height: 38,
    borderRadius: 19,
    backgroundColor: COACH_C.avatarBg,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  bodyCol: {
    flex: 1,
    minWidth: 0,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 8,
  },
  title: {
    fontSize: 14,
    fontWeight: '800',
    color: COACH_C.ink,
    flexShrink: 1,
  },
  progress: {
    fontSize: 10.5,
    fontWeight: '700',
    color: COACH_C.muted,
    fontVariant: ['tabular-nums'],
    flexShrink: 0,
  },
  text: {
    fontSize: 13,
    lineHeight: 19,
    color: COACH_C.body,
    marginTop: 3,
  },
  footerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 9,
  },
  skip: {
    fontSize: 12,
    fontWeight: '600',
    color: COACH_C.muted,
    paddingVertical: 4,
  },
  gotItBtn: {
    backgroundColor: COACH_C.accent,
    borderRadius: 9999,
    paddingHorizontal: 18,
    paddingVertical: 8,
  },
  gotItText: {
    fontSize: 12.5,
    fontWeight: '700',
    color: COACH_C.accentInk,
  },
  hintRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  hintDot: {
    width: 7,
    height: 7,
    borderRadius: 3.5,
    backgroundColor: COACH_C.accent,
  },
  hintText: {
    fontSize: 11.5,
    fontWeight: '700',
    color: COACH_C.accent,
  },
  pressed: {
    transform: [{ scale: 0.96 }],
  },
  // Arrow (rotated square) anchoring the card to the target.
  arrow: {
    position: 'absolute',
    width: COACH_ARROW_SIZE,
    height: COACH_ARROW_SIZE,
    backgroundColor: COACH_C.card,
    transform: [{ rotate: '45deg' }],
  },
  arrowUp: {
    top: -COACH_ARROW_SIZE / 2 + 0.5,
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderColor: COACH_C.cardBorder,
    borderTopLeftRadius: 3,
  },
  arrowDown: {
    bottom: -COACH_ARROW_SIZE / 2 + 0.5,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: COACH_C.cardBorder,
    borderBottomRightRadius: 3,
  },
});
